import FEATURE from './FeatureUtil';
import Constants from './Constants';

export default {
  getPanelConfigurationOrDefault(panelConfig, properties = {}, recommendations, zone) {
    if (panelConfig.orientation === Constants.CAROUSEL_TYPE.VERTICAL) {
      return Promise.resolve(properties);
    }
    if (properties.prosContentEnabled && zone === 'HP_ZONE_C') {
      return this.isHomePageProsContentEnabled(properties);
    } else if (properties.prosCollectionsEnabled && zone === 'HP_ZONE_D') {
      return this.isHomePageProsCollectionEnabled(properties);
    }

    return this.getHorizontalRedesignPropertiesOrDefault(properties);
  },

  isZoneExperimented(zone) {
    return (['HP_ZONE_C', 'HP_ZONE_D'].indexOf(zone) > -1);
  },

  getPropertiesByExperiment(properties, experiemntCheckFn, getPropertiesFn) {
    return new Promise((resolve) => {
      Promise.all([
        experiemntCheckFn(),
        getPropertiesFn(properties),
      ])
        .then(([enabled, redesignProps]) => {
          let props = Object.assign({}, redesignProps);
          if (!enabled) {
            props = Object.assign({}, properties, {
              panelInDisguise: true,
            });
          }
          resolve(props);
        });
    });
  },

  isHomePageProsContentEnabled(properties) {
    return this.getPropertiesByExperiment(properties, FEATURE.HP_PROS_CONTENT_TREATMENTS.isEnabled, this.getHorizontalRedesignPropertiesOrDefault);
  },

  isHomePageProsCollectionEnabled(properties) {
    return this.getPropertiesByExperiment(properties, FEATURE.HP_PROS_COLLECTION_TREATMENTS.isEnabled, this.getHorizontalRedesignPropertiesOrDefault);
  },

  getHorizontalRedesignPropertiesOrDefault(properties) {
    return new Promise((resolve) => {
      Promise.all([
        FEATURE.PROS_REDESIGN_TREATMENT_A.isEnabled(),
        FEATURE.PROS_REDESIGN_TREATMENT_B.isEnabled(),
      ])
        .then((recipes) => {
          const [treatmentA, treatmentB] = recipes;
          let props = Object.assign({}, properties);
          if (treatmentA) {
            props = Object.assign(properties, {
              prosZoneRedesignEnabled: true,
              prosThumbnailRedesignTreatmentAEnabled: true,
            });
          } else if (treatmentB) {
            props = Object.assign(properties, {
              prosZoneRedesignEnabled: true,
              prosThumbnailRedesignTreatmentBEnabled: true,
            });
          }

          resolve(props);
        });
    });
  },
};
